import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import SeriesList from "src/shared/SeriesList";
import Paginate from "src/shared/Paginate";

import { TvShowsData } from "src/types/tvSeriesData";
import Loader from "../../shared/Loader";
import { getTVShowsList } from "src/shared/api";

const AiringToday = () => {
  const [data, setData] = useState<TvShowsData | null>(null);

  let { currentPage } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    getTVShowsList("airing_today", currentPage as string).then((response) =>
      setData(response.data),
    );
  }, [currentPage]);

  const onChangePage = (selectedNumber: { selected: number }) => {
    navigate(`/airing_today/${selectedNumber.selected + 1}`);
  };

  if (!data) {
    return <Loader />;
  }

  return (
    <div>
      <SeriesList shows={data.results} />

      <Paginate onPageChange={onChangePage} pageCount={data.total_pages} />
    </div>
  );
};

export default AiringToday;
